export default __webpack_public_path__ + "static/media/file-blank.750904ba.svg";